<template>
  <element>
    <nav-breadcrumb :menu="[{label: '角色权限'}, {label: '配置功能'}]"/>
    <div class="bg-purple of">
      <el-row>
        <panel label="配置功能">
          <div class="qxedit" v-for="(prefix, idx) in Object.keys(roleFunctionListFormat)" :key="idx">
            <div class="qxeditone">
              <p>{{prefix}}</p>
            </div>
            <ul class="qxedittwo_two">
              <li v-for="(item, idx2) in roleFunctionListFormat[prefix]" :key="idx2">
                <p><el-checkbox v-model="roleFunctionIds" :label="item.f__functionId" border>{{item.f__functionName}}</el-checkbox></p>
              </li>
            </ul>
          </div>
        </panel>
      </el-row>
    </div>
    <el-row>
      <el-button type="primary" @click="handleSave">保存</el-button>
      <el-button @click="$router.go(-1)">返回</el-button>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../../utils/xhr.js'

  export default {
    data: function () {
      return {
        roleType: '',
        roleFunction: {},
        roleFunctionIds: [],
        roleFunctionList: []
      }
    },
    watch: {
      roleFunction: function (val) {
        this.roleFunctionIds = val.map(item => {
          if (item.rf__disabled == 'N') return item.f__functionId
        })

      }
    },
    computed: {
      roleFunctionListFormat() {
        return this.roleFunctionList.reduce(
          (total, item) => {
            let functionName = item.f__functionName;
            let prefix = functionName.substr(functionName.indexOf('【')+1,functionName.indexOf('】') -1) || '其它'
            if (typeof total[prefix] == "undefined") {
              total[prefix] = []
            }
            total[prefix].push(item)

            return total
          },
          {}
        )
      },
      roleId() {
        return this.$route.query.roleId || ''
      }
    },
    mounted: function () {
      this.getRoleFunction()
    },
    methods: {
      //查询角色拥有的功能
      getRoleFunction: function () {
        xhr.getRoleFunction({
          'r.roleId': this.roleId
        }, res => {
          this.roleFunction = res.data.data || []
          this.roleFunctionList = res.data.data || []
        })
      },
      //保存角色菜单
      handleSave: function () {
        xhr.updateRoleFunction({
          'r.roleId': this.roleId,
          function: this.roleFunctionIds.join(',')
        }, res => {
          this.getRoleFunction()
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigRoleFunctionEdit.vue